import * as React from 'react';
import { inject } from 'mobx-react';
import { EGDSIcon, EGDSIconSize } from '@egds/react-core/icons';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { useLocalization } from '@shared-ui/localization-context';
import { PlaybackSubHeading } from './playback-sub-heading';
export const CollapsedSearchPlayback = inject('searchResults')(({
  searchResults
}) => {
  const {
    formatText,
    formatDateString
  } = useLocalization();
  if (!searchResults) return null;
  const {
    searchCriteria,
    isLoading
  } = searchResults;
  const {
    destination,
    guestCount
  } = searchCriteria || {};
  const destinationMessage = isLoading ? destination : destination || formatText('hotels.searchResults.playback.destinationMissing.text');
  const getSearchDateRange = () => {
    const searchCriteria = searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria;
    if (!searchCriteria || !searchCriteria.startDate || !searchCriteria.endDate) {
      return '';
    }
    const startDate = formatDateString(searchCriteria.startDate, {
      skeleton: 'MMMd'
    });
    const endDate = formatDateString(searchCriteria.endDate, {
      skeleton: 'MMMd'
    });
    return formatText('hotels.searchResults.playback.dateRange', startDate, endDate);
  };
  return React.createElement(EGDSLayoutFlex, {
    dataTestId: "collapsed-search-playback"
  }, React.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, React.createElement(EGDSSpacing, {
    margin: {
      inlinestart: 'one',
      inlineend: 'two'
    }
  }, React.createElement(EGDSIcon, {
    description: formatText('hotels.searchResults.backToSearchResults.a11yLabel'),
    id: "playback-icon",
    name: "search",
    size: EGDSIconSize.MEDIUM,
    title: formatText('hotels.searchResults.title')
  }))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    margin: {
      block: 'two',
      inlinestart: 'one'
    }
  }, React.createElement("div", null, React.createElement(PlaybackSubHeading, {
    destinationMessage: destinationMessage,
    dateRange: getSearchDateRange(),
    guestCountTitle: guestCount && formatText('hotels.searchResults.numberOfGuests', guestCount) || undefined
  })))));
});